import React, { Component } from 'react';
import { getSceneIcon } from '../../Common/Common';

export default class Display_Scene_Cell_Icon extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let icon = getSceneIcon(this.props.scene_info.icon);
		let img_width = this.props.cell_width / 3;

		return (
			<div style={{ display: 'inline-block', textAlign: 'center' }}>
				<img src={icon} style={{ width: img_width }} />
			</div>
		)
	}
}